import { Box, Text } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { LectureSearchCardPopover } from '@/components/ui/shared/lecture/LectureSearchCard/components/LectureSearchCardPopover';

export const LectureSearchCardTitle: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Box zIndex={3} position="relative">
      <LectureSearchCardPopover
        triggerSlot={
          <Box h="66px">
            <Text as="h3" textStyle="groteskL" fontWeight="bold" fontFamily="heading" noOfLines={3}>
              {children}
            </Text>
          </Box>
        }
        bodySlot={
          <Text textStyle="groteskL" fontFamily="heading" fontWeight="bold">
            {children}
          </Text>
        }
      />
    </Box>
  );
};
